import { getCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'

/**
 * Site takeovers that waive the LuxPlus+ joining fee for all customers for their duration.
 * Add a takeover's id here to make it waive the fee
 */
const JOINING_FEE_WAIVED_TAKEOVER_IDS: Array<string> = []

/**
 * Plain state selector — works both via useAppSelector (components) and direct call
 * with getState() (Redux thunks), so there's no separate hook/non-hook variant needed.
 * Generic entry point for any reason the joining fee should be force-waived, not tied
 * to takeovers specifically — the takeover check is just today's implementation.
 */
export function getLuxPlusWaiveJoiningFeeOverride(state: App.State): boolean {
  const currentTakeoverId = getCurrentSiteTakeover(state)?.id
  return !!currentTakeoverId && JOINING_FEE_WAIVED_TAKEOVER_IDS.includes(currentTakeoverId)
}
